import React from 'react';
import styled from '@emotion/styled';
import ListItemSkeleton from './ListItemSkeleton';

const JobList = styled.div`
  width: 100%;
`;

const JobListSkeletonLoader = () => (
  <JobList>
    <ListItemSkeleton />
    <ListItemSkeleton />
    <ListItemSkeleton />
  </JobList>
);

export default JobListSkeletonLoader;
